export default "__VITE_ASSET__CE$gVcWM__"